import Vue from 'vue'
// 全局API_BASE_URL
// process.env.VUE_APP_API_BASE_URL = "";
// Vue.prototype.API_BASE_URL = process.env.VUE_APP_API_BASE_URL
export const baseUrl = Vue.prototype.API_BASE_URL



// WEBPACK FOOTER //
// ./src/utils/index.js